export default {
  methods: {
    hasChartData(value) {
      if (value === null || value === undefined) {
        return false;
      }

      if (Array.isArray(value)) {
        if (value.length === 0) {
          return false;
        }

        return value.some((item) => this.hasChartData(item));
      }

      if (typeof value === "string") {
        return value.trim().length > 0;
      }

      if (typeof value === "number") {
        return !Number.isNaN(value);
      }

      if (typeof value === "boolean") {
        return true;
      }

      if (value instanceof Date) {
        return !Number.isNaN(value.getTime());
      }

      if (typeof value === "object") {
        const values = Object.values(value);

        if (values.length === 0) {
          return false;
        }

        return values.some((item) => this.hasChartData(item));
      }

      return true;
    },
  },
};
